"use client";

import Image from "next/image";
import Link from "next/link";
import ShareButtons from "@/components/blog/ShareButtons";
import TableOfContents, { type TocEntry } from "@/components/blog/TableOfContents";
import { articlePath, type BlogCardData } from "@/lib/blog";

/** Desktop-Sidebar: Inhaltsverzeichnis, Teilen, verwandte Artikel. */
export default function StickySidebar({
  article,
  entries,
  related,
}: {
  article: { title: string; slug: string; category: string };
  entries: TocEntry[];
  related: BlogCardData[];
}) {
  return (
    <div className="sticky top-24 flex flex-col gap-4 ">
      <TableOfContents entries={entries} />

      <div className="card-flat bg-white/70 p-5">
        <ShareButtons title={article.title} path={articlePath(article)} />
      </div>

      {related.length > 0 && (
        <div className="card-flat bg-white/70 p-5">
          <p className="text-xs font-bold uppercase tracking-widest text-ink-faint mb-4">
            Auch interessant
          </p>
          <ul className="flex flex-col gap-4">
            {related.slice(0, 3).map((item) => (
              <li key={item.slug}>
                <Link href={articlePath(item)} className="group flex items-start gap-3">
                  <span className="relative w-16 h-12 shrink-0 rounded-lg overflow-hidden">
                    <Image
                      src={item.image}
                      alt={item.imageAlt}
                      width={750}
                      height={874}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </span>
                  <span className="flex flex-col gap-1 min-w-0">
                    <span className="text-sm font-semibold leading-snug text-ink group-hover:text-accent transition-colors line-clamp-2">
                      {item.title}
                    </span>
                    <span className="text-xs text-ink-faint">
                      {item.readingMinutes} Min. Lesezeit
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
